import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CardDetail from "./CardDetail";
import CardEmpty from "./CardEmpty";
import useGetTranslations from "../../../../../dealers/assets/js/dealers_map/hooks/useGetTranslations";
import {
    setFirstItem,
    setSecondItem,
    setThirdItem,
} from "../redux/modelsComparatorSlice";

export default function Items({ id, quotation, testDrive }) {
    const [translations] = useGetTranslations(
        "/api/vehicles/get_translations/"
    );

    const dispatch = useDispatch();

    const [openModel, setOpenModel] = useState(false); // para abrir y cerrar el select de modelos
    const [openVersion, setOpenVersion] = useState(false); // para abrir y cerrar el select de versiones
    const [model, setModel] = useState(null); // para mostrar el modelo seleccionado
    const [serieSelected, setSerieSelected] = useState(null); // para guardar la serie seleccionada
    const [version, setVersion] = useState(null); // para mostrar el nombre de la versión seleccionada
    const [versionSelected, setVersionSelected] = useState(null); // para guardar la versión seleccionada

    const series = useSelector((state) => state.modelsComparator.allSeries);
    const versions = useSelector((state) => state.modelsComparator.allVersions);

    const handleOpenModel = () => {
        // para abrir y cerrar el select de modelos
        setOpenModel(!openModel);
    };

    const handleOpenVersion = () => {
        // para abrir y cerrar el select de versiones
        setOpenVersion(!openVersion);
    };

    const selectModel = (e) => {
        // para seleccionar el modelo
        const modelName = e.target.dataset.value;
        setModel(modelName);
        // Guardar la serie completa con su ID
        const selectedSerie = series.find((s) => s.name === modelName);
        setSerieSelected(selectedSerie);
    };

    const selectVersion = (e) => {
        // para seleccionar la versión
        setVersion(e.target.dataset.value);
        setVersionSelected(
            versions.find((v) => v.name === e.target.dataset.value)
        );
    };

    const listVersions = series
        ?.filter((e) => e.name === model)
        .map((e) =>
            e.versions.map((v) => (
                <li
                    className="option"
                    data-value={v.name}
                    onClick={selectVersion}
                    style={{
                        backgroundColor: version === v.name ? "#E8E8E8" : null,
                    }}
                    key={v.id}
                >
                    {v.name}
                </li>
            ))
        );

    useEffect(() => {
        versionSelected && id == "firstItem"
            ? dispatch(setFirstItem(versionSelected))
            : null;
        versionSelected && id == "secondItem"
            ? dispatch(setSecondItem(versionSelected))
            : null;
        versionSelected && id == "thirdItem"
            ? dispatch(setThirdItem(versionSelected))
            : null;
    }, [versionSelected]);

    return (
        <div className="comparator-items">
            <div
                className="ego-form__field first --select-react --filled-react"
                onClick={handleOpenModel}
                style={{
                    borderColor: openModel ? "#A7A7A8" : "#E8E8E8",
                    borderBottom: openModel ? "none" : null,
                }}
            >
                <input
                    type="hidden"
                    name="fees"
                    className="hidden-control"
                    value="ES"
                />
                <label className="ego-form__field__label">
                    {translations.text4}
                </label>
                <div className="ego-form__field__select-display">
                    <span className="value-placeholder">
                        {model ? model : translations.text5}
                    </span>
                    <i className="caret"></i>
                </div>
                {openModel && series ? (
                    <div className="options-container">
                        <ul>
                            {series.map((e, i) => {
                                return (
                                    <li
                                        className="option"
                                        data-value={e.name}
                                        onClick={selectModel}
                                        style={{
                                            backgroundColor:
                                                model == e ? "#E8E8E8" : null,
                                        }}
                                        key={i}
                                    >
                                        {e.name}
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                ) : null}
            </div>

            <div
                className={
                    model
                        ? "ego-form__field --select-react --filled-react"
                        : "ego-form__field --select-react --filled-react --disabled"
                }
                onClick={handleOpenVersion}
                style={{
                    borderColor: openVersion ? "#A7A7A8" : "#E8E8E8",
                    borderBottom: openVersion ? "none" : null,
                }}
            >
                <input
                    type="hidden"
                    name="fees"
                    className="hidden-control"
                    value="ES"
                />
                <label className="ego-form__field__label">Versión</label>
                <div className="ego-form__field__select-display">
                    <span className="value-placeholder">
                        {version ? version : translations.text6}
                    </span>
                    <i className="caret"></i>
                </div>
                {openVersion && listVersions ? (
                    <div className="options-container">
                        <ul>{listVersions}</ul>
                    </div>
                ) : null}
            </div>

            {model && versionSelected ? (
                <CardDetail versionSelected={versionSelected} serieSelected={serieSelected} id={id} quotation={quotation} testDrive={testDrive} />
            ) : (
                <CardEmpty />
            )}
        </div>
    );
}
